var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useRef } from 'react';
import { CodeInput, Link, LoadingSpinner, Text, Toast } from '@paypalcorp/pp-react';
import { getProp } from '../common/utils';
import { TRY_ANOTHER_WAY } from '../common/views';
export default ({ authEventHandler, challengeId, isAutoOtp = false, localizedContent, logger, csrf, sessionID, maskedPhoneNumber, sendOtpChallenge, setView, updateAfterOtpSent, verifyOtp, }) => {
    const [otp, setOtp] = useState('');
    const [otpFieldError, setOtpFieldError] = useState('');
    const [showSpinner, setShowSpinner] = useState(false);
    const [showResendSpinner, setShowResendSpinner] = useState(false);
    const [showOtpResent, setShowOtpResent] = useState(false);
    const [showOtpResentFailed, setShowOtpResentFailed] = useState(false);
    const ref = useRef([]); // For CodeInput to be able to auto focus
    useEffect(() => {
        ref.current[0].focus();
        logger.track('otp_rendered');
        logger.flush({ csrf, sessionID });
        authEventHandler({
            event: isAutoOtp ? 'autoOtpPageRendered' : 'otpPageRendered',
        });
    }, []);
    const handleResendOtpClicked = () => __awaiter(void 0, void 0, void 0, function* () {
        setShowResendSpinner(true);
        setOtpFieldError('');
        authEventHandler({
            event: 'resendOtpLinkClicked',
        });
        logger.track('resend_otp_started');
        const response = yield sendOtpChallenge({ selectedChallengeId: challengeId });
        const nonce = getProp(response, 'data.otp.sendOtpNotification.nonce');
        if (nonce) {
            updateAfterOtpSent({ response });
            setShowOtpResent(true);
            setTimeout(() => {
                setShowOtpResent(false);
            }, 5000);
        }
        else {
            setShowOtpResentFailed(true);
            setTimeout(() => {
                setShowOtpResentFailed(false);
            }, 5000);
        }
        logger.track('resend_otp_' + (nonce ? 'succeeded' : 'failed'));
        setShowResendSpinner(false);
    });
    // const getErrorMessageDom = (otpFieldError) => <span>{localizedContent('invalidCodeMessage')}</span>;
    const handleChangeOtp = (pin) => __awaiter(void 0, void 0, void 0, function* () {
        if (showSpinner) {
            return;
        }
        if (otpFieldError) {
            setOtpFieldError('');
        }
        setOtp(pin);
        if (pin.match(/\s/)) {
            return;
        }
        if (!pin.match(/\d{6}/)) {
            setOtpFieldError(React.createElement("div", { style: { textAlign: 'left' } }, localizedContent('invalidCodeMessage')));
            return;
        }
        const startTime = Date.now();
        authEventHandler({ event: 'beginLogin', data: { loginMethod: 'otp' } });
        setShowSpinner(true);
        logger.track('otp_submitted');
        const response = yield verifyOtp({ securityCode: pin.trim() });
        const accessToken = getProp(response, 'data.otp.verifyOtp.accessToken');
        const status = getProp(response, 'data.otp.verifyOtp.status');
        logger.track('otp_' + (accessToken && status !== 'failed' ? 'succeeded' : 'failed'));
        logger.track(`cpl_otp_login|${JSON.stringify({ start: startTime, tt: Date.now() - startTime })}`);
        if (accessToken) {
            // In case of stepup the status will be "failed"
            logger.track(status === 'failed' ? 'login_contingency' : 'user_logged_in');
            authEventHandler({ event: status === 'failed' ? 'loginFailed' : 'loggedIn', data: { accessToken } });
        }
        else {
            logger.track('invalid_otp');
            setOtp('');
            setOtpFieldError(React.createElement("div", { style: { textAlign: 'left' } }, localizedContent('invalidCodeMessage')));
            setShowSpinner(false);
            authEventHandler({
                event: 'loginFailed',
                data: { loginMethod: 'otp' },
            });
        }
        logger.flush({ csrf, sessionID });
    });
    return (React.createElement("div", { "data-testid": "view-code-input", className: "fade-in", style: { textAlign: 'center' } },
        showOtpResent && (React.createElement(Toast, { "data-testid": "success-toast", message: localizedContent('otpResentMessage'), duration: 5000, isSuccess: true })),
        showOtpResentFailed && (React.createElement(Toast, { "data-testid": "failure-toast", message: localizedContent('genericErrorMessage'), duration: 5000 })),
        React.createElement("div", null,
            React.createElement(Text, { size: "xl", style: { fontWeight: 'bold', fontSize: '1.25rem', margin: '15px 0', color: '#222222' } }, isAutoOtp ? localizedContent('autoOtpHeading') : localizedContent('otpHeading')),
            React.createElement("p", { style: { margin: '15px 0' } },
                localizedContent('codeSent', { maskedPhoneNumber }),
                showResendSpinner ? (React.createElement("span", { style: { marginLeft: '5px' } }, localizedContent('resending'))) : (React.createElement(Link, { "data-testid": "link-get-new-code", style: { marginLeft: '5px', cursor: 'pointer' }, onClick: handleResendOtpClicked }, localizedContent('getNewCode')))),
            React.createElement(CodeInput, { ref: ref, name: "otp", value: otp, onChange: handleChangeOtp, errorText: otpFieldError, type: "tel" })),
        React.createElement("br", null),
        React.createElement("div", null,
            showSpinner && (React.createElement(LoadingSpinner, { style: { margin: '12px auto' }, screenReaderText: localizedContent('loading') })),
            React.createElement(Link, { style: { margin: '15px 0', cursor: 'pointer' }, "data-testid": "link-try-another-way", onClick: () => {
                    logger.track('otp_opted_out');
                    authEventHandler({
                        event: 'tryAnotherWayClicked',
                    });
                    setView(TRY_ANOTHER_WAY);
                } }, localizedContent('tryAnotherWay')))));
};
